import React from "react";
import { Button, Col, FormLabel, Row } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { PageListBean } from "../ds/client_ds.js";
import {
  AddressBean,
  RestReadRequest,
  RestWarehouseListRequest,
  WarehouseBean,
  WarehouseSearchCriteria,
} from "../ds/ds.js";
import { DeleteIcon } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  DataGridColumnDefinition,
  EditableDataGrid,
  InputCheckbox,
  InputTextbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmpty, isEmptyArray } from "../gui_components/Util.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";
class LocationListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
    this.state = {};
  }
  componentDidMount() {}
  componentDidUpdate() {
    this.setInputFocus();
    //
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  editWarehouse = (val, rowdata) => {
    this.props.editWarehouse(val);
  };
  deleteLocation = (val, rowData) => {
    this.props.deleteLocation(val, rowData);
  };

  columnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "LocationCode",
        "code",
        0,
        true,
        this.editWarehouse
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Description", "description")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Company", "companyCode")
    );
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails("Default", "isDefault")
        .setEditableDetails(false, "", null, false, null, true, null, null)
    );
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails("Active", "isActive")
        .setEditableDetails(false, "", null, false, null, true, null, null)
    );
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails("IsHoldWH", "isHoldingWareHouse")
        .setEditableDetails(false, "", null, false, null, true, null, null)
    );
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails("IsInitialInvWh", "isInitialInventoryWareHouse")
        .setEditableDetails(false, "", null, false, null, true, null, null)
    );
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails("IsReservedWh", "isReservedWareHouse")
        .setEditableDetails(false, "", null, false, null, true, null, null)
    );
    // columnList.push(
    //   new DataGridColumnDefinition()
    //     .setDetails(
    //       "Remove",
    //       <DeleteIcon />,
    //       0,
    //       false,
    //       null,
    //       false,
    //       null, //image link call back
    //       "1em", //min-width
    //       "20%", //max-width
    //       false,
    //       null,
    //       false
    //     )
    //     .setEditableDetails(
    //       false,
    //       "",
    //       null,
    //       true,
    //       this.deleteLocation,
    //       false,
    //       null
    //     )
    // );
    return columnList;
  };
  opentypeforms = (e) => {
    if (e.detail === 1) this.props.opentypeforms();
  };

  render() {
    let warehouseData = this.props.warehouseData;
    return (
      <div>
        <div>
          <Row>
            <Col sm="1">
              <FormLabel id="searchBarLabel">Warehouse</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                type="text"
                name="code"
                onChange={this.props.onChange}
                value={warehouseData.code}
                style={{ "text-transform": "uppercase" }}
                enterKeyEventHandler={this.props.enterKeyEventHandler}
                ref={this.listFormCodeRef}
                isMandatory={true}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="text-center"
                onClick={(e) => this.opentypeforms(e)}
              >
                Go
              </Button>
            </Col>
          </Row>
        </div>
        <div className="div_Custom_4">
          <EditableDataGrid
            columnsList={this.columnDefinitions()}
            dataList={this.props.warehouse_list}
          />
        </div>
      </div>
    );
  }
}

class LocationEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();

    this.state = {};
  }

  componentDidMount() {
    this.setInputFocus();
  }

  componentDidUpdate() {
    //
  }
  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  onAddressChange = (e) => {
    this.props.onAddressChange(e);
  };
  saveWarehouse = (e) => {
    this.props.saveWarehouse(this.state.warehouseData);
  };

  closeWarehouseEntryForm() {
    this.props.closeWarehouseEntryForm();
  }
  render() {
    let warehouseData = this.props.warehouseData;
    let addressData = this.props.addressData;
    let isDisableFields = this.props.isDisableFields;

    return (
      <div>
        <div>
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Company Code</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="companyCode"
                type="text"
                placeholder="Enter CompanyCode"
                onChange={this.onChange}
                value={warehouseData.companyCode}
                disabled="true"
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Warehouse</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="code"
                type="text"
                placeholder="Enter WarehouseCode"
                onChange={this.onChange}
                value={warehouseData.code}
                style={{ "text-transform": "uppercase" }}
                disabled={isDisableFields}
                ref={this.codeRef}
                isMandatory={true}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Warehouse Name</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="description"
                type="text"
                placeholder="Enter Name"
                onChange={this.onChange}
                value={warehouseData.description}
                style={{ "text-transform": "capitalize" }}
                isMandatory={true}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>Default</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputCheckbox
                type="checkbox"
                name="isDefault"
                onChange={this.onChange}
                checked={warehouseData.isDefault}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Active</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputCheckbox
                type="checkbox"
                name="isActive"
                onChange={this.onChange}
                checked={warehouseData.isActive}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Hold WareHouse</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputCheckbox
                type="checkbox"
                name="isHoldingWareHouse"
                onChange={this.onChange}
                checked={warehouseData.isHoldingWareHouse}
              />
            </Col>

            <Col sm="1">
              <FormLabel>Initial Inv WareHouse</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputCheckbox
                type="checkbox"
                name="isInitialInventoryWareHouse"
                onChange={this.onChange}
                checked={warehouseData.isInitialInventoryWareHouse}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Reserved WareHouse</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputCheckbox
                type="checkbox"
                name="isReservedWareHouse"
                onChange={this.onChange}
                checked={warehouseData.isReservedWareHouse}
              />
            </Col>
          </Row>

          <br />
        </div>
        <div>
          <Row>
            <Col sm="2">
              <FormLabel className="address">Address</FormLabel>
            </Col>
          </Row>
          <hr class="row_border"></hr>
          <Row>
            <Col sm="2">
              <FormLabel>Address1</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="address1"
                type="text"
                placeholder="Enter Address1"
                onChange={this.onAddressChange}
                value={addressData.address1}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
            <Col sm="2">
              <FormLabel>Country</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                onChange={this.props.onCountryChange}
                name="country"
                placeholder="country"
                valuePropery="code"
                descriptionProperty="description"
                value={addressData.country}
                lookupRequired={true}
                lookupHandler={this.props.countryLookupHandler}
                enterKeyEventHandler={this.props.countryCodeEnterKeyEvent}
                autoCompleteListData={
                  this.props.countryCodePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.props.displayAutoCompleteCountryCodeList
                }
                showAutoCompleteList={
                  this.props.showAutoCompleteCountryCodeList
                }
              />
            </Col>
            <Col sm="2">
              <FormLabel>Phone#2</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="phone2"
                type="text"
                placeholder="Enter Phone2"
                onChange={this.onAddressChange}
                value={addressData.phone2}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="2">
              <FormLabel>Address2</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="address2"
                type="text"
                placeholder="Enter Address2"
                onChange={this.onAddressChange}
                value={addressData.address2}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
            <Col sm="2">
              <FormLabel>Zip</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="zip"
                type="text"
                placeholder="Enter Zip"
                onChange={this.onAddressChange}
                value={addressData.zip}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
            <Col sm="2">
              <FormLabel>Mobile#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="mobilePhone"
                type="text"
                placeholder="Enter MobileNo"
                onChange={this.onAddressChange}
                value={addressData.mobilePhone}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="2">
              <FormLabel>City</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.props.onCityChange}
                name="city"
                placeholder="city"
                value={addressData.city}
                lookupRequired={true}
                lookupHandler={this.props.cityLookupHandler}
                enterKeyEventHandler={this.props.cityEnterKeyEvent}
                autoCompleteListData={
                  this.props.cityPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.props.displayAutoCompleteCityList}
                showAutoCompleteList={this.props.showAutoCompleteCityList}
              />
            </Col>
            <Col sm="2">
              <FormLabel>Contact Person</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="contactPerson"
                type="text"
                placeholder="ContactPerson"
                onChange={this.onAddressChange}
                value={addressData.contactPerson}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
            <Col sm="2">
              <FormLabel>Email</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="email"
                type="text"
                placeholder="Enter Email"
                onChange={this.onAddressChange}
                value={addressData.email}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="2">
              <FormLabel>State</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.props.onStateChange}
                name="state"
                placeholder="state"
                value={addressData.state}
                lookupRequired={true}
                lookupHandler={this.props.stateLookupHandler}
                enterKeyEventHandler={this.props.stateEnterKeyEvent}
                autoCompleteListData={
                  this.props.statePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.props.displayAutoCompleteStateList
                }
                showAutoCompleteList={this.props.showAutoCompleteStateList}
              />
            </Col>
            <Col sm="2">
              <FormLabel>Phone#1</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="phone1"
                type="text"
                placeholder="Enter PhoneNo1"
                onChange={this.onAddressChange}
                value={addressData.phone1}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
            <Col sm="2">
              <FormLabel>Website</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="website"
                type="text"
                placeholder="Enter Website"
                onChange={this.onAddressChange}
                value={addressData.website}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
          </Row>
          <br />
        </div>
      </div>
    );
  }
}

class LocationList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      warehouse_list: [],
      response: {},
      pageTitle: "Warehouse",
      warehouseData: new WarehouseBean(),
      pageList: new PageListBean(),
      criteria: new WarehouseSearchCriteria(),
      addressData: new AddressBean(),
      companyCode: "",
      countries: [],
      cities: [],
      states: [],
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      currentPageNumber: 0,
      totalCount: 0,
      isWarehouseListFormOpen: true,
      isWarehouseEntryFormOpen: false,
      isShowNodes: false,
      selectedNode: "headerView",
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isEntryFormOpen: false,
      isDisableFields: false,
      countryLookupHandler: null,
      showAutoCompleteCountryCodeList: true,
      countryCodePageListForAutoCompleteList: new Array(),
      cityLookupHandler: null,
      showAutoCompleteCityList: true,
      cityPageListForAutoCompleteList: new Array(),
      stateLookupHandler: null,
      showAutoCompleteStateList: true,
      statePageListForAutoCompleteList: new Array(),
      isShowExitButton: true,
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...this.cache };

    const countries = new Array();
    if (!isEmptyArray(attribute_cache.countries))
      countries.push(...attribute_cache.countries);
    this.state.countries = countries;
    const states = new Array();
    if (!isEmptyArray(attribute_cache.states))
      states.push(...attribute_cache.states);
    this.state.states = states;
    const cities = new Array();
    if (!isEmptyArray(attribute_cache.cities))
      cities.push(...attribute_cache.cities);
    this.state.cities = cities;
    this.loadPage(1);
    this.cleardata();
    this.initLookupHandlers();
  }

  moduleCaption = "Warehouse";
  initLookupHandlers = () => {
    let cityLookupHandler = new GenericAttributeLookupHandler(
      this.state.cities,
      "City"
    );
    this.setState({ cityLookupHandler: cityLookupHandler });
    let stateLookupHandler = new GenericAttributeLookupHandler(
      this.state.states,
      "State"
    );
    this.setState({ stateLookupHandler: stateLookupHandler });

    let countryLookupHandler = new GenericAttributeLookupHandler(
      this.state.countries,
      "Country"
    );
    this.setState({ countryLookupHandler: countryLookupHandler });
  };
  opentypeforms = () => {
    let warehouseCode = this.state.warehouseData;
    this.editWarehouse(warehouseCode.code);
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.opentypeforms();
    }, 200);
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  cleardata = () => {
    let warehouseData = new WarehouseBean();
    warehouseData.companyCode = this.companyCode;
    let addressData = new AddressBean();
    addressData.companyCode = this.companyCode;
    this.setState({
      warehouseData: warehouseData,
      addressData: addressData,
    });
  };
  saveWarehouseResponse = (response) => {
    if (response.data.success) {
      this.handleresponse(response.data);
      this.loadPage(1);
      this.cleardata();
      this.clearError();
      this.closeWarehouseEntryForm();
      this.setState({ isShowCode: false });
    } else {
      this.handleresponse(response.data);
    }
  };
  saveWarehouse = (warehouseData) => {
    if (warehouseData.isFetched == true) {
      if (SecurityAccessManager.LocationMaintenanceEdit_IsAccessible()) {
        MasterService.updateWarehouse(
          warehouseData,
          this.saveWarehouseResponse
        );
      } else {
        let errMsg = "Edit Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (SecurityAccessManager.LocationMaintenanceCreate_IsAccessible()) {
        MasterService.createWarehouse(
          warehouseData,
          this.saveWarehouseResponse
        );
      } else {
        let errMsg = "Create Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  editWarehouseResponse = (response) => {
    if (response.data != null) {
      if (response.data.warehouseBean != null) {
        let warehouseData = response.data.warehouseBean;
        if (warehouseData.address != null) {
          this.setState({
            addressData: warehouseData.address,
          });
        }
        this.setState({
          warehouseData: warehouseData,
        });
        this.disable();
      }
    }
    this.openWarehouseEntryForm();
  };
  editWarehouse = (warehouseCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = warehouseCode;
    if (SecurityAccessManager.LocationMaintenanceView_IsAccessible()) {
      MasterService.readWarehouse(readrestInput, this.editWarehouseResponse);
    } else {
      let errMsg = "View Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  onChange = (e) => {
    let temp_warehousedata = this.state.warehouseData;
    temp_warehousedata[e.target.name] = e.target.value;
    this.setState({
      warehouseData: temp_warehousedata,
    });
  };
  onAddressChange = (e) => {
    let temp_addressData = this.state.addressData;
    temp_addressData[e.target.name] = e.target.value;
    this.setState({ addressData: temp_addressData });
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }

    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  save = () => {
    let warehouseData = this.state.warehouseData;
    warehouseData.companyCode = this.companyCode;
    warehouseData.code = this.state.warehouseData.code.toUpperCase();
    warehouseData.address = this.state.addressData;
    this.clearError();
    this.saveWarehouse(warehouseData);
  };
  back = () => {
    this.clearError();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closeWarehouseEntryForm();
    this.componentDidMount();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  openWarehouseEntryForm = () => {
    this.setState({
      isWarehouseListFormOpen: false,
      isWarehouseEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
    });
    this.hideAlertCallBack();
  };
  closeWarehouseEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isWarehouseListFormOpen: true,
      isWarehouseEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,

      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
    });
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };
  loadWarehouseResponse = (response) => {
    if (response.data != null && response.data.attributePageList != null) {
      let warehouseList = new Array();
      if (!isEmptyArray(response.data.attributePageList.attributes)) {
        warehouseList = response.data.attributePageList.attributes;
        // warehouseList.map((Info) => {
        //   if (Info.isActive == true) {
        //     Info.isActive = "True";
        //   } else {
        //     Info.isActive = "False";
        //   }
        // });
      }
      let pageList = this.state.pageList;
      pageList.currentPage = response.data.attributePageList.currentPage;
      pageList.pageSize = response.data.attributePageList.pageSize;
      pageList.totalCount = response.data.attributePageList.totalCount;
      this.setState({
        warehouse_list: warehouseList,
        pageList: pageList,
      });
    }
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  loadPage = (pageNumber) => {
    let criteria = new WarehouseSearchCriteria();
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadWarehousePage(pageInput, criteria);
  };
  loadWarehousePage = (pageList, searchCriteria) => {
    let criteria = new WarehouseSearchCriteria();
    criteria = searchCriteria;
    let requestInput = new RestWarehouseListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    this.state.pageList = pageList;
    if (SecurityAccessManager.LocationMaintenanceView_IsAccessible()) {
      MasterService.getWarehousePageListByCriteria(
        requestInput,
        this.loadWarehouseResponse,
        this.loadWarehouseResponseError
      );
    } else {
      let errMsg = "View Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  deleteLocation = (val, rowData) => {
    let criteria = new WarehouseSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.code = rowData.code;
    if (SecurityAccessManager.LocationMaintenanceDelete_IsAccessible()) {
      MasterService.deleteWarehouse(
        criteria,
        this.deleteWarehouseResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Delete Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    let errMsg = error;
    let errList = [];
    errList.push(errMsg);

    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
    });
  };
  loadWarehouseResponseError = (error) => {
    ShowError("Error : " + error);
  };
  deleteWarehouseResponse = (response) => {
    this.handleresponse(response.data);
    this.loadPage(1);
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  onCountryChange = (e) => {
    let country = e.target.value;
    this.state.showAutoCompleteCountryCodeList = true;
    let addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
    if (isEmpty(country)) {
      this.state.showAutoCompleteCountryCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
      let addressData = this.state.addressData;
      addressData.country = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        addressData: addressData,
        countryCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && country !== "") {
      this.readcountryCodeBySearchString(country);
    }
    if (e.target.name == "country") {
      addressData["country"] = e.target.value;
      let country_List = this.state.countries;
      country_List.map((country) => {
        if (country.code == e.target.value) {
          addressData["country"] = country.code;

          this.state.showAutoCompleteCountryCodeList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ addressData: addressData });
  };
  readcountryCodeBySearchString(searchString) {
    let countryData = this.state.countries;
    let simpleAutoCompleteList = new Array();
    if (countryData.length > 0 && countryData != null) {
      countryData.map((countryDatas) => {
        let simpleItemBean = {
          code: countryDatas.code,
          description: countryDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecountryLists) =>
        simpleAutoCompletecountryLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      countryCodePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  countryCodeEnterKeyEvent = (e) => {
    let addressData = this.state.addressData;
    let country = e.target.value;

    addressData["country"] = e.target.value;
    let country_List = this.state.countries;
    let countryBean = null;
    country_List.map((country) => {
      if (country.code == e.target.value) {
        countryBean = country;
      }
    });
    if (!isEmpty(countryBean)) {
      let addressData = this.state.addressData;
      addressData.country = countryBean.code;

      this.setState({
        addressData: addressData,
        countryCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCountryCodeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCountryCodeList: showAutoCompleteList });
  };
  onCityChange = (e) => {
    let city = e.target.value;
    this.state.showAutoCompleteCityList = true;
    let temp_addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteCityList;
    if (isEmpty(city)) {
      this.state.showAutoCompleteCityList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCityList;
      let temp_addressData = this.state.addressData;
      temp_addressData.city = "";

      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        addressData: temp_addressData,
        cityPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && city !== "") {
      this.readcityBySearchString(city);
    }
    if (e.target.name == "city") {
      temp_addressData["city"] = e.target.value;
      let city_List = this.state.cities;
      city_List.map((city) => {
        if (city.code == e.target.value) {
          temp_addressData["city"] = city.code;

          this.state.showAutoCompleteCityList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCityList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ addressData: temp_addressData });
  };
  readcityBySearchString(searchString) {
    let cityData = this.state.cities;
    let simpleAutoCompleteList = new Array();
    if (cityData.length > 0 && cityData != null) {
      cityData.map((cityDatas) => {
        let simpleItemBean = {
          code: cityDatas.code,
          description: cityDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecityLists) =>
        simpleAutoCompletecityLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ cityPageListForAutoCompleteList: filteredSuggestions });
  }
  cityEnterKeyEvent = (e) => {
    let temp_addressData = this.state.addressData;
    let city = e.target.value;

    temp_addressData["city"] = e.target.value;
    let city_List = this.state.cities;
    let cityBean = null;
    city_List.map((city) => {
      if (city.code == e.target.value) {
        cityBean = city;
      }
    });
    if (!isEmpty(cityBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.city = cityBean.code;

      this.setState({
        addressData: temp_addressData,
        cityPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCityList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCityList: showAutoCompleteList });
  };
  onStateChange = (e) => {
    let state = e.target.value;
    this.state.showAutoCompleteStateList = true;

    let temp_addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteStateList;

    if (isEmpty(state)) {
      this.state.showAutoCompleteStateList = false;
      let showAutoCompleteList = this.state.showAutoCompleteStateList;
      let temp_addressData = this.state.addressData;
      temp_addressData.state = "";

      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        addressData: temp_addressData,
        statePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && state !== "") {
      this.readstateBySearchString(state);
    }
    if (e.target.name == "state") {
      temp_addressData["state"] = e.target.value;
      let state_List = this.state.states;
      state_List.map((state) => {
        if (state.code == e.target.value) {
          temp_addressData["state"] = state.code;

          this.state.showAutoCompleteStateList = false;
          let showAutoCompleteList = this.state.showAutoCompleteStateList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ addressData: temp_addressData });
  };
  readstateBySearchString(searchString) {
    let stateData = this.state.states;
    let simpleAutoCompleteList = new Array();
    if (stateData.length > 0 && stateData != null) {
      stateData.map((stateDatas) => {
        let simpleItemBean = {
          code: stateDatas.code,
          description: stateDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletestateLists) =>
        simpleAutoCompletestateLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ statePageListForAutoCompleteList: filteredSuggestions });
  }
  stateEnterKeyEvent = (e) => {
    let temp_addressData = this.state.addressData;
    let state = e.target.value;

    temp_addressData["state"] = e.target.value;
    let state_List = this.state.states;
    let stateBean = null;
    state_List.map((state) => {
      if (state.code == e.target.value) {
        stateBean = state;
      }
    });
    if (!isEmpty(stateBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.state = stateBean.code;

      this.setState({
        addressData: temp_addressData,
        statePageListForAutoCompleteList: new Array(),
      });
    }
  };

  displayAutoCompleteStateList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteStateList: showAutoCompleteList });
  };
  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}
        {this.state.isWarehouseListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
          />
        )}
        {!this.state.isWarehouseListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
            isShowTitle={true}
          />
        )}
        {this.state.isWarehouseListFormOpen && (
          <LocationListForm
            warehouse_list={this.state.warehouse_list}
            pageList={this.state.pageList}
            criteria={this.state.criteria}
            opentypeforms={this.opentypeforms}
            warehouseData={this.state.warehouseData}
            editWarehouse={this.editWarehouse}
            deleteLocation={this.deleteLocation}
            enterKeyEventHandler={this.enterKeyEventHandler}
            onChange={this.onChange}
          />
        )}
        {!this.state.isWarehouseListFormOpen && (
          <LocationEntryForm
            {...this.state}
            warehouseData={this.state.warehouseData}
            addressData={this.state.addressData}
            isDisableFields={this.state.isDisableFields}
            closeWarehouseEntryForm={this.closeWarehouseEntryForm}
            saveWarehouse={this.saveWarehouse}
            editWarehouse={this.editWarehouse}
            onChange={this.onChange}
            onAddressChange={this.onAddressChange}
            onCountryChange={this.onCountryChange}
            countryCodeEnterKeyEvent={this.countryCodeEnterKeyEvent}
            displayAutoCompleteCountryCodeList={
              this.displayAutoCompleteCountryCodeList
            }
            onCityChange={this.onCityChange}
            cityEnterKeyEvent={this.cityEnterKeyEvent}
            displayAutoCompleteCityList={this.displayAutoCompleteCityList}
            onStateChange={this.onStateChange}
            stateEnterKeyEvent={this.stateEnterKeyEvent}
            displayAutoCompleteStateList={this.displayAutoCompleteStateList}
          />
        )}
      </div>
    );
  }
}
function LocationAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="app">
        <LocationList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default LocationAttributeModule;
